import { Component } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { NgcCookieConsentService } from 'ngx-cookieconsent';
import { PageService } from './services/page.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent {
  title = 'mudico';
  pagetitle = 'mudico';
  fullScreenPage = false;

  constructor(private router: Router, private cookieService: NgcCookieConsentService, private pageService:PageService) {

    router.events.subscribe((event:any) => {
        if(event instanceof NavigationStart) {
          this.pageService.resetCurrentHeader();
        }
        if(event instanceof NavigationEnd) {
          this.pagetitle = event.url.slice(1);
          this.fullScreenPage = (event.url != undefined && event.url.includes("underconstruction"));
          //this.fullScreenPage = true;
        }
    });
  }
}
